import "../images/png/logo_courtier_et_pret.png";
import "../images/png/logo_courtier_et_pret_blanc.png";
import "../images/svg/logo_courtier_et_pret_cadre.svg";
import "../images/svg/logo_courtier_et_pret_blanc.svg";
import "../images/png/marker.png";
import "../images/png/bulle.png";
import "../images/svg/defiscalisation.svg";



// WEBPACK FOOTER //
// ./src/js/images.js